import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import React from 'react'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('app')

  if (!el) return

  createInertiaApp({
    resolve: name => {
      const pages = import.meta.glob('../pages/**/*.tsx', { eager: true })
      return pages[`../pages/${name}.tsx`]
    },
    setup({ el, App, props }) {
      createRoot(el).render(React.createElement(App, props))
    }
  })
})
